export default __webpack_public_path__ + "static/media/comfy-pepe.84bfd033.png";